import React from 'react';
import { FeatureGate } from '../../contexts/FeatureFlagContext';
import DeploymentFrequencyDoraCard from '../../components/dora/DeploymentFrequencyDoraCard';
import LeadTimeDoraCard from '../../components/dora/LeadTimeDoraCard';
import ChurnRatioCard from '../../components/dora/ChurnRatioCard';
import CodeCompositionCard from '../../components/dora/CodeCompositionCard';
import CodeCompositionOverTimeCard from '../../components/dora/CodeCompositionOverTimeCard';

export default function StreamsOverviewPanel({
  deploymentLoading,
  deploymentDora,
  deploymentDoraMeta,
  deploymentWindowDays,
  deploymentPeriod,
  doraChartType,
  setDeploymentPeriod,
  setDoraChartType,
  leadTimeLoading,
  leadTimeDora,
  leadTimeDoraMeta,
  leadTimePeriod,
  leadTimeChartType,
  setLeadTimePeriod,
  setLeadTimeChartType,
  churnLoading,
  churnData,
  churnWindowDays,
  churnPeriod,
  churnChartType,
  setChurnPeriod,
  setChurnChartType,
  metricsFetchScope,
}: any) {
  return (
    <>
      {/* DORA metrics (stream: all projects) — two-up + churn row matches organisation dashboard rhythm */}
      <div className="section-block-mdl card-grid-2-mdl">
        <DeploymentFrequencyDoraCard
          loading={deploymentLoading}
          noData={!deploymentDora}
          dates={deploymentDoraMeta?.mergeDeploymentsByDay?.dates}
          counts={deploymentDoraMeta?.mergeDeploymentsByDay?.counts}
          windowDays={deploymentWindowDays}
          period={deploymentPeriod}
          chartType={doraChartType}
          onPeriodChange={setDeploymentPeriod}
          onChartTypeChange={setDoraChartType}
          emptyMessage="No merges to default branch in this window across this stream. Sync repos to load commits."
        />
        <LeadTimeDoraCard
          loading={leadTimeLoading}
          noData={!leadTimeDora}
          dates={leadTimeDoraMeta?.leadTimeByDeployment?.dates}
          leadTimeMinutes={leadTimeDoraMeta?.leadTimeByDeployment?.leadTimeMinutes}
          meanLeadTimeMinutes={leadTimeDoraMeta?.meanLeadTimeMinutes}
          period={leadTimePeriod}
          chartType={leadTimeChartType}
          onPeriodChange={setLeadTimePeriod}
          onChartTypeChange={setLeadTimeChartType}
          emptyMessage="No merges to default branch in this window across this stream. Sync repos to load commits."
        />
      </div>
      <div className="section-block-mdl card-grid-2-mdl items-stretch">
        <ChurnRatioCard
          className="!mt-0 h-full"
          loading={churnLoading}
          noData={
            !churnData ||
            !churnData.dates?.length ||
            (churnData.ratios?.length > 0 && churnData.ratios.every((r) => r === 0))
          }
          dates={churnData?.dates}
          ratios={churnData?.ratios}
          windowDays={churnWindowDays}
          period={churnPeriod}
          chartType={churnChartType}
          onPeriodChange={setChurnPeriod}
          onChartTypeChange={setChurnChartType}
          emptyMessage="No commit data in this window across this stream."
        />
        <FeatureGate flag="ui.streams.cycleTimeSection">
          <CodeCompositionCard className="!mt-0 h-full" fetchScope={metricsFetchScope} />
        </FeatureGate>
      </div>

      <FeatureGate flag="ui.streams.cycleTimeSection">
        <div className="section-block-mdl">
          <CodeCompositionOverTimeCard className="!mt-0" fetchScope={metricsFetchScope} />
        </div>
      </FeatureGate>
    </>
  );
}
